const mockOffers = [
  {
    type: 'taxi',
    offers: [
      {
        id: 'd5d70b4c-27bf-4680-9f8c-07e02f10b16e',
        title: 'Upgrade to a business class',
        price: 158
      },
      {
        id: '1ef388a5-0a48-4e27-957f-6e265c8c3958',
        title: 'Choose the radio station',
        price: 92
      },
      {
        id: 'cdd79f71-1520-4b85-9135-98f009f4a5d6',
        title: 'Choose temperature',
        price: 180
      },
      {
        id: 'd44375b4-467b-4111-a86e-11a1f6e209a5',
        title: 'Drive quickly, I\'m in a hurry',
        price: 141
      },
      {
        id: '6e77caf0-e083-497d-9b05-226272a3c557',
        title: 'Drive slowly',
        price: 170
      }
    ]
  },
  {
    type: 'bus',
    offers: [
      {
        id: '70b8b20a-aee2-4716-93a8-6090e90aaa5f',
        title: 'Infotainment system',
        price: 46
      },
      {
        id: 'f5ecc997-833b-4794-8a19-c9bf61830e15',
        title: 'Order meal',
        price: 125
      },
      {
        id: 'a3ebdd4e-9021-43be-ae41-6ba5b1a2c8c7',
        title: 'Choose seats',
        price: 135
      }
    ]
  },
  {
    type: 'train',
    offers: [
      {
        id: '5ac88f21-7096-40bf-b505-70f2ecda701c',
        title: 'Book a taxi at the arrival point',
        price: 80
      },
      {
        id: '59644519-f72b-4be3-b914-e8bf034ece5a',
        title: 'Order a breakfast',
        price: 178
      },
      {
        id: '4406d403-df60-4ede-bc53-cdb424cc40f1',
        title: 'Wake up at a certain time',
        price: 34
      }
    ]
  },
  {
    type: 'flight',
    offers: [
      {
        id: '21403e61-3256-485d-b648-771a1f2b3a1e',
        title: 'Choose meal',
        price: 151
      },
      {
        id: 'f50debc7-c76f-425b-bf31-edd84c5877ad',
        title: 'Choose seats',
        price: 169
      },
      {
        id: 'd64143b4-9527-4470-8ed1-5290d589b96b',
        title: 'Upgrade to comfort class',
        price: 185
      },
      {
        id: '0e87c0f3-7abc-4ba4-b4c8-e8774c6b86b0',
        title: 'Upgrade to business class',
        price: 147
      },
      {
        id: '3968d985-0310-490e-a0c7-f49f5f0b07a1',
        title: 'Add luggage',
        price: 143
      },
      {
        id: '471bf489-5102-4f18-a58e-69291145a936',
        title: 'Business lounge',
        price: 31
      }
    ]
  },
  {
    type: 'check-in',
    offers: [
      {
        id: '34adc3d6-9d70-4f96-ad91-5fb75a3a6e6d',
        title: 'Choose the time of check-in',
        price: 85
      },
      {
        id: 'f1a1984c-c1a7-4a8d-883d-5c8fcdb2fc84',
        title: 'Choose the time of check-out',
        price: 82
      },
      {
        id: '7daefd03-2d9a-4143-9419-ebba3b2247fd',
        title: 'Add breakfast',
        price: 89
      },
      {
        id: 'b75c96ec-f12f-403b-91be-abc0110b643f',
        title: 'Laundry',
        price: 169
      },
      {
        id: '1108cac6-d5e7-48ec-aebd-2e213444b1ee',
        title: 'Order a meal from the restaurant',
        price: 42
      }
    ]
  },
  {
    type: 'sightseeing',
    offers: []
  },
  {
    type: 'ship',
    offers: [
      {
        id: '7356e656-94e6-4f36-8bb5-163a17cfa841',
        title: 'Choose meal',
        price: 162
      },
      {
        id: 'b1bd6cc2-51ce-42b2-99f5-9df12a7f97f9',
        title: 'Choose seats',
        price: 109
      },
      {
        id: 'f91cfb4a-c241-4e22-8bf1-e5e8ab4bb222',
        title: 'Upgrade to comfort class',
        price: 72
      },
      {
        id: 'c5424871-ab68-48e9-95ae-da33312cb24d',
        title: 'Upgrade to business class',
        price: 133
      },
      {
        id: 'f0484591-cfda-45c8-9286-c222d8e1b701',
        title: 'Add luggage',
        price: 118
      },
      {
        id: '2fcaf275-8d86-4eb4-b4d8-e12f8c07edf3',
        title: 'Business lounge',
        price: 94
      }
    ]
  },
  {
    type: 'drive',
    offers: [
      {
        id: 'b8681284-e9c9-4b79-b14b-e33b0acc7591',
        title: 'With automatic transmission',
        price: 134
      },
      {
        id: 'b892f09d-d7c1-43d5-bb61-c320125af75d',
        title: 'With air conditioning',
        price: 68
      }
    ]
  },
  {
    type: 'restaurant',
    offers: [
      {
        id: 'aebb0086-2a49-4cfd-966f-969802c90981',
        title: 'Choose live music',
        price: 119
      },
      {
        id: '6b59afee-9409-41ec-9a52-ce3d0829c4ef',
        title: 'Choose VIP area',
        price: 73
      }
    ]
  }
];

export {mockOffers};
